import { api } from './client';

/** EL VIGILANTE DE GRUPOS (api/vigia/vigia.routes.ts). */
export interface MiembroVigia {
  id?: string;
  nombre: string;
  alias: string[];
  waJid: string | null;
  duenoDelNumero: boolean;
  activo: boolean;
}

export type EstadoAviso = 'PENDIENTE' | 'AVISADO' | 'RECORDADO' | 'RESUELTO' | 'DESCARTADO' | 'FALLO';

export interface AvisoVigia {
  id: string;
  grupoNombre: string | null;
  autor: string | null;
  texto: string;
  resumen: string | null;
  porMencion: boolean;
  estado: EstadoAviso;
  error: string | null;
  createdAt: string;
  miembro: { nombre: string };
}

export interface GrupoVigia {
  jid: string;
  nombre: string;
  vigilado: boolean;
}

export const verEquipo = () => api.get<MiembroVigia[]>('/api/vigia/equipo');
export const guardarEquipo = (equipo: MiembroVigia[]) => api.put<MiembroVigia[]>('/api/vigia/equipo', equipo);
export const verAvisos = () => api.get<AvisoVigia[]>('/api/vigia/avisos');
export const verGrupos = () => api.get<GrupoVigia[]>('/api/vigia/grupos');
export const guardarGruposApagados = (apagados: string[]) => api.put<{ apagados: string[] }>('/api/vigia/grupos', { apagados });
